import { Component } from '@angular/core';
import { LcsChipGridComponentBase } from 'src/app/common-components/chip-grid/chip-grid';
import { ExtensionOption } from 'src/app/pages/extension-register/models/extension-option.interface';

@Component({
    selector: 'ndt-extension-chip-grid',
    templateUrl: 'extension-chip-grid.component.html',
    standalone: false
})
export class ExtensionChipGridComponent extends LcsChipGridComponentBase<ExtensionOption> {
   trackBy(item: ExtensionOption | null) {
      return item?.extensionId;
   }
}
